import moment from 'moment'
import LineChart from '../LineChart';
import Loading from '@/components/Core/Loading'

export default {
  name: 'LocationChart',
  components: {
    LineChart,
    Loading,
  },
  props: {
    date: {
      type: Date,
      required: false,
    },
    model: {
      type: Array,
      required: true,
    },
    max: {
      type: Number,
      required: false,
      default: 0,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      // chartData: {
      //   labels: [
      //     'Red',
      //     'Blue',
      //     'Yellow'
      //   ],
      //   datasets: [{
      //     data: [300, 50, 100],
      //     backgroundColor: 'rgb(255, 205, 86)',
      //   }]
      // },
      chartOptions: {
        // responsive: false,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          animation: false,
          yAxes: [
            {
              display: true,
              ticks: {
                suggestedMin: 0,
                max: this.maxCount,
                beginAtZero: true,
              }
            }
          ]
        }
      },
    }
  },
  beforeMount () {
    console.log('model', this.model)
    this.chartOptions.scales.yAxes[0].ticks.max = this.maxCount
  },
  computed: {
    maxCount() {
      const aryMax = (a, b) => {
        return Math.max(a, b);
      }
      const max = this.model
        .map(item => item.activeCount)
        .reduce(aryMax);
      return Math.max(10, Math.ceil(max / 10) * 10);
    },

    items() {
      const start = moment(this.date)
      const end = moment(this.date).add(1, 'months')

      let list = []
      for (var i = 0, l = end.diff(start, 'days'); i < l; i++) {
        const d = start.format('YYYY年MM月DD日')
        const i = this.model.findIndex(item => item.activedate === d)
        list.push({
          label: d.substr(-3),
          value: i === -1 ? 0 : this.model[i].activeCount,
        })
        start.add(1, 'days')
      }
      return list
    },

    chartData() {
      return {
        labels: this.items.map(item => item.label),
        datasets: [
          {
            data: this.items.map(item => item.value),
            backgroundColor: '#03a0f0',
            lineTension: 0,
          }
        ]
      }
    }
  },
  watch: {
    date: function(to) {
      this.chartOptions.scales.yAxes[0].ticks.max = this.maxCount
    },
  },
  methods: {

  }
}
